import { render, staticRenderFns } from "./teachBehaviorAnalysis.vue?vue&type=template&id=16d98f50&scoped=true"
import script from "./teachBehaviorAnalysis.vue?vue&type=script&lang=js"
export * from "./teachBehaviorAnalysis.vue?vue&type=script&lang=js"
import style0 from "./teachBehaviorAnalysis.vue?vue&type=style&index=0&id=16d98f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d98f50",
  null
  
)

export default component.exports